import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import withReactiveFields from "../../helpers/reactivefields";
import withInputFields from "../../helpers/inputfields";
import { withProperties, getValueAtPath } from "../../../../utils";
import { USES_CHARGE_POLLING, USES_ORDER_REFERENCE } from "../../../../charge/flags";
import InitView from "./views/init";
import ConfirmView from "./views/confirm";
import DetailsView from "./views/details";
import { capitecPaymentOptions, selectCapitecPaymentOptionFromList } from "../../../../collections/capitecpaymentoptions";
import withCountdownTimer from "../../helpers/countdowntimer";
import ErrorState from "../../../common/error";
import PendingView from "../../common/pending";
import { CHECKOUT_CLOSE_EVENT } from "../../../helpers/tokens";


const METHOD = 'capitec';
const METHOD_NAME = 'Capitec Pay';
const CHARGE_MODE = USES_CHARGE_POLLING | USES_ORDER_REFERENCE;

const VIEWS = [ InitView, ConfirmView, DetailsView ];

let $this;

function mount() {
    return (dispatch) => {
        getChargeLimit.call(this, () => {
            const VIEW = (
                this.SHOULD_VALIDATE_CHARGE && (DetailsView || (this.SHOULD_VALIDATE_CHARGE = false))
            ) || InitView;

            VIEW && VIEW.activate(() => this.startListeningForCancellation());

            // Temporarily remove check for high risk merchant implementation
            // VIEW && VIEW.activate(() => {
            //     VIEW === InitView && getMerchantCategory(this).then((response) => {
            //         this.USE_CUSTOMER_ID = response;
            //     })
          
            //     this.startListeningForCancellation();
            // });
        });

        $this = this;

        getChargeFee();
    }
}

function getChargeData() {
    return ({
        payment_type: 'capitec'
    })
}

function getViewsContext(data, store) {
    const REACTIVE_FIELDS = ['CAN_GO_BACK', 'CURRENT_TIME', 'SHOULD_VALIDATE_CHARGE', 'USE_CUSTOMER_ID', 'CAPITEC_INSTRUCTION'];
    const TIMER_DURATION = 3 * 60; // (3 minutes)
    const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);
    let listening = false;

    const cancellationListener = () => {
        stopListeningForCancellation();
        cancelDetailsViewProcess();
    }
    
    const startListeningForCancellation = () => {
        if (listening !== true) {
            addEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

            listening = true;
        }
    }
    
    const stopListeningForCancellation = () => {
        if (listening === true) {
            removeEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

            listening = false
        }
    }

    const cancelDetailsViewProcess = () => {
        $context.SHOULD_VALIDATE_CHARGE = false;
        $context.CURRENT_TIME = null;
        $context.$resetContext();
        $context.$charge && $context.$charge.cancel();
    }

    $context.CAN_GO_BACK = true;

    withInputFields($context, {
        accountnumber: null,
        phonenumber: null,
        customernumber: null,
        capitecPaymentOption: {
            options: capitecPaymentOptions,
            selector: selectCapitecPaymentOptionFromList.bind($context, capitecPaymentOptions),
            defaultValue: capitecPaymentOptions[0]
        },
    })

    $context.$subscribe('SHOULD_VALIDATE_CHARGE', (currentValue, oldValue) => {
        setTimeout(() => {
            if (!(oldValue || oldValue === currentValue) && currentValue === true) {
                DetailsView && DetailsView.activate(() => {
                    $context.$timer.start() 
                    setTimeout(() => {
                        const currentPaymentMethod = getValueAtPath($context, 'STATE.method.current')
                        if (currentPaymentMethod === 'capitec' && $context.SHOULD_VALIDATE_CHARGE === true) {
                            $this.$charge.poll($this.pollConfig);
                        }
                    }, 5000);
                });
            }
        }, 0);
    });

    withProperties($context, {
        TIMER_DURATION,
        startListeningForCancellation,
        stopListeningForCancellation,
        $resetContext() {
            $context.$inputs.$reset('accountnumber');
            $context.$inputs.$reset('phonenumber');
            $context.$inputs.$reset('customernumber');
            $context.CAPITEC_INSTRUCTION = null;
            $context.CAN_GO_BACK = false;
        },

        INIT_VIEW: callback => {
            InitView && (
                $context.$resetContext(),
                InitView.activate(callback)
            );
        },
    });

    return withCountdownTimer($context, {
        duration: TIMER_DURATION,
        onTick() {  
            $context.CURRENT_TIME = $context.$timer.current
            const currentTimeValue = getValueAtPath($context, 'CURRENT_TIME.time') || null;
            const pendingMessage = getValueAtPath($context, '$$data.data.chargeResponseMessage') || getValueAtPath($context, '$$data.data.acctvalrespmsg');

            if (currentTimeValue && currentTimeValue === 61) {
                $context.CAPITEC_INSTRUCTION = pendingMessage;
                ConfirmView && ConfirmView.activate($context);
            }
        },
        onFinish() {
            if ($context.$charge.cancel()) {
                $context.SHOULD_VALIDATE_CHARGE = false;
                $context.CURRENT_TIME = null;
                const lastChargeResponseCode = getValueAtPath($context, '$$data.data.chargeResponseCode') || null;
                const lastStatus = getValueAtPath($context, '$$data.status');
                $context.$resetContext();

                if (lastChargeResponseCode && lastChargeResponseCode === '02' && lastStatus !== 'failed') {
                    PendingView && PendingView.activate($context)
                } else {
                    InitView && InitView.activate();

                    setTimeout(() => $context.dispatch(
                        ErrorState.actions.updateErrorMessage('capitec.expiry.error', 20)
                    ), 100)
                }
            }
        }
    })
}

export {
    METHOD,
    METHOD_NAME,
    CHARGE_MODE,
    VIEWS,
    mount,
    getChargeData,
    getViewsContext
}
